<template>
  <div class="bannerWrapper">
    <div class="seasonsBannerContainer" :class="{ collapsed: isCollapsed }">
      <img src="/img/seasons-banner-mobile.png" alt="" class="seasonsBanner" />
      <div class="bannerContent">
        <div class="bannerTop">
          <div class="prizeFundTitle">{{ $t('prizeFund2026') }}</div>
        </div>
        <Transition name="expand">
          <div v-if="!isCollapsed" class="bannerBottom">
            <div class="bannerButtonWrapper">
              <button class="bannerButton seasonsButton" @click="openModal('seasons')">{{ $t('seasons') }}</button>
              <div class="buttonBadge">50 000$</div>
            </div>
            <div class="bannerButtonWrapper">
              <button class="bannerButton jackpotButton" @click="openModal('jackpot')">{{ $t('jackpot') }}</button>
              <div class="buttonBadge">50 000$</div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <button class="toggleButton" @click="isCollapsed = !isCollapsed">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="{ rotated: isCollapsed }"
      >
        <path
          d="M7 14L12 9L17 14"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <SeasonPrizeInfoPopup v-model="isModalOpen" :type="modalType" :mobile="true" />
  </div>
</template>

<script lang="ts" setup>
import SeasonPrizeInfoPopup from '~/widgets/seasons-prize/SeasonPrizeInfoPopup.vue';

type PrizeType = 'seasons' | 'jackpot';

const isModalOpen = ref(false);
const modalType = ref<PrizeType>('seasons');
const isCollapsed = ref(true);

const { isScrolling } = useLeaderboardScroll();

const openModal = (type: PrizeType) => {
  modalType.value = type;
  isModalOpen.value = true;
};

// Автоматически сворачиваем баннер при скролле
watch(isScrolling, (scrolling) => {
  if (scrolling && !isCollapsed.value) {
    isCollapsed.value = true;
  }
});
</script>

<style lang="scss" scoped>
.bannerWrapper {
  position: relative;
  width: 100%;
  max-width: 300px;
  margin: 0 auto 16px;
}

.seasonsBannerContainer {
  position: relative;
  width: 100%;
  overflow: hidden;
  transition: max-height 0.4s ease;
  border-radius: 10px;

  &.collapsed {
    max-height: 86px;
    border-radius: 10px;
  }

  &:not(.collapsed) {
    max-height: 500px;
  }
}

.seasonsBanner {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

.bannerContent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px 30px;
}

.bannerTop {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.prizeFundTitle {
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  color: #ffffff;
  text-shadow:
    1px 1px 0 #000,
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    0px 1px 0 #000,
    0px -1px 0 #000,
    1px 0px 0 #000,
    -1px 0px 0 #000;
  white-space: nowrap;
}

.bannerBottom {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.bannerButtonWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
}

.bannerButton {
  padding: 6px 24px;
  border-radius: 48px;
  cursor: pointer;
  transition: opacity 0.2s;
  border: 2px solid #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 17.78px;
  text-align: center;

  &:hover {
    opacity: 0.9;
  }
}

.seasonsButton {
  background: linear-gradient(180deg, #17343e 0%, #010303 100%);
  color: #fff;
}

.jackpotButton {
  background: linear-gradient(270deg, #ffee33 -69.44%, #ffc800 -1.3%, #fff15d 45.82%, #ffc800 105.56%);
  color: #05141b;
}

.buttonBadge {
  padding: 3px 10px;
  border-radius: 24px;
  background: #fff;
  color: #05141b;
  position: absolute;
  top: 28px;
  box-shadow: 0px -4px 2px 0px #00000040 inset;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
}

.toggleButton {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #000000;
  border: 1px solid #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: transform 0.2s ease;

  &:active {
    transform: translateX(-50%) translateY(50%) scale(0.95);
  }

  svg {
    color: #ffffff;
    transition: transform 0.3s ease;
    transform: rotate(180deg);

    &.rotated {
      transform: rotate(0deg);
    }
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 200px;
}
</style>
